import React, { useState } from 'react';
import { Icon } from 'rhinostyle';
import { findDurationFromMilliseconds } from '../../helpers/DateHelpers';
import RhinoVoipVoicemailPlayer from '../RhinoVoipVoicemailPlayer';

const TRANSCRIPTION_PREVIEW_LENGTH = 310;

const VoipCallEvent = ({ event }) => {
  const {
    formattedTimestamp,
    callerNumber,
    destinationNumber,
    callerContactName,
    destinationContactName,
    direction,
    status,
    memberName,
    duration,
    voicemailMessageId,
    voicemailDuration,
    voicemailTranscription: transcription,
  } = event;

  const [transcriptionExpanded, setTranscriptionExpanded] = useState(false);

  const isInbound = direction === 'inbound';
  const isOutbound = direction === 'outbound';

  const otherParty = isInbound
    ? (callerContactName || callerNumber || 'Unknown')
    : (destinationContactName || destinationNumber || 'Unknown');

  const directionLabel = isInbound ? 'Incoming' : isOutbound ? 'Outgoing' : 'Call'; // eslint-disable-line no-nested-ternary

  let statusLabel = status
    ? status.charAt(0).toUpperCase() + status.slice(1)
    : '';
  if (statusLabel && voicemailDuration) {
    statusLabel += ` (${voicemailDuration}s)`;
  }
  // Show the responsible member next to the status. Inbound answered → "Answered By X",
  // outbound → "Outgoing From X". Voicemail/missed/no_answer don't get attribution —
  // no member actually handled the call, the system took it.
  if (memberName) {
    if (isOutbound) {
      statusLabel = `${statusLabel} From ${memberName}`;
    } else if (isInbound && status === 'answered') {
      statusLabel = `${statusLabel} By ${memberName}`;
    }
  }

  return (
    <div className="convo__event convo__event--voip-call" data-cypress="voipCallEvent">
      <div className="convo__event__title">
        <Icon bump="up" icon="phone" className="convo__event__icon" />
        <span className="convo__event__voip-direction">{directionLabel}</span>
        {' call '}
        {isInbound ? 'from ' : 'to '}
        <strong>{otherParty}</strong>
        {statusLabel && (
          <span className="convo__event__voip-status"> — {statusLabel}</span>
        )}
      </div>
      <div className="convo__event__subtext">
        {formattedTimestamp}
        {duration > 0 && ` (${findDurationFromMilliseconds(duration)})`}
      </div>
      {voicemailMessageId && (
        <div className="convo__event__voicemail">
          <RhinoVoipVoicemailPlayer voicemailMessageId={voicemailMessageId} />
          {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */}
          <div
            className="convo__event__transcription"
            onClick={() => {
              if (transcription && transcription.length > TRANSCRIPTION_PREVIEW_LENGTH) {
                setTranscriptionExpanded((prev) => !prev);
              }
            }}
          >
            {transcription ? (
              <>
                {transcriptionExpanded || transcription.length <= TRANSCRIPTION_PREVIEW_LENGTH
                  ? transcription
                  : `${transcription.slice(0, TRANSCRIPTION_PREVIEW_LENGTH)}...`}
                {transcription.length > TRANSCRIPTION_PREVIEW_LENGTH && (
                  <span className="convo__event__transcription-toggle">
                    {transcriptionExpanded ? ' Show less' : ' Show more'}
                  </span>
                )}
              </>
            ) : (
              'No Transcription Available'
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default VoipCallEvent;
